let moment = require('moment');

module.exports = {
    // переводим локлаьное время в utc и форматируем в строку
    getFormattedDate (unixStamp) {
        let dateMoment = moment.unix(unixStamp);
        // преобразуем локальное время в UTC+0
        return unixStamp ? moment(dateMoment).utc().add(dateMoment.utcOffset(), 'm').toISOString() : null;
    }
};



// WEBPACK FOOTER //
// ./actions/dateFormatter.js